import { createSlice } from '@reduxjs/toolkit';
import { setUserTypes } from './api-calls/userTypes';

const INITIAL_STATE = {
  userTypes: [],
};

export const userTypesSlice = createSlice({
  name: 'userTypes',
  initialState: INITIAL_STATE,
  reducers: {
    resetUserTypes: (state, action) => {
      state.userTypes = INITIAL_STATE.userTypes;
    },
  },
  extraReducers: {
    [setUserTypes.fulfilled]: (state, action) => {
      state.userTypes = action.payload.data.Response.UserTypeDetails;
    },
  },
});

export const { resetUserTypes } = userTypesSlice.actions;

export default userTypesSlice.reducer;
